import { render } from "./HeartIcon.vue?vue&type=template&id=633a1f82&scoped=true"
import script from "./HeartIcon.vue?vue&type=script&lang=js"
export * from "./HeartIcon.vue?vue&type=script&lang=js"

import "./HeartIcon.vue?vue&type=style&index=0&id=633a1f82&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633a1f82"]])

export default __exports__